import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, getId, createItem, updateItem, deleteById } from "./surveyAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "survey/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchSurvey = createAsyncThunk(
  "survey/fetchSurvey",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("survey/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});
export const fetchIdNoloading = createAsyncThunk(
  "survey/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("survey/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk("survey/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "survey/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const surveySlice = createSlice({
  name: "survey",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchSurvey.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchSurvey.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = surveySlice.actions;

export const selectData = (state) => state.survey.data;
export const selectSurvey = (state) => state.survey.data;
export const selectId = (state) => state.survey.dataId;
export const selectLoading = (state) => state.survey.loading;
export const selectError = (state) => state.survey.error;
export const selectPageNo = (state) => state.survey.pageNo;
export const selectPageSize = (state) => state.survey.pageSize;
export const selectTotalRecord = (state) => state.survey.totalRecord;
export const selectSelected = (state) => state.survey.selected;
export const selectResult = (state) => state.survey.result;

export default surveySlice.reducer;
